<template>
  <form v-on:keyup.enter="submit" style="width: 100%; height: 100%; position: relative;">
    <v-layout
      class="small-book-form"
      column
      align-content-start
      style="height: 92%; overflow-y: scroll;"
    >
      <v-flex>
        <v-row justify="end">
          <v-btn color="green" dark x-small @click="expand">expand</v-btn>
        </v-row>
        <v-layout row>
          <v-row>
            <v-flex shrink>
              <CustomerSearchInput :bookingForm="bookingForm" :updateMode="updateMode" />
            </v-flex>
            <v-flex shrink px-1>
              <BookingDateTimeInput :bookingForm="bookingForm" />
            </v-flex>
            <v-row justify="end">
              <v-flex shrink>
                <v-btn icon dark @click="forceAddLeadPAX = !forceAddLeadPAX">
                  <v-icon color="grey darken-2">person</v-icon>
                </v-btn>
              </v-flex>
            </v-row>
          </v-row>
        </v-layout>
        <v-flex>
          <BusinessCustomerDetailsInput
            v-if="userIsBusiness || forceAddLeadPAX || bookingHasBusinessAttributes()"
            :bookingForm="bookingForm"
          />
        </v-flex>
        <v-layout style="position: relative;" pt-2 pb-1>
          <v-layout pr-5 mr-2 px-1 row wrap align-start>
            <v-flex>
              <BookingLocationInput
                flatField
                @locationChanged="pickupUpdated"
                v-model="bookingForm.booking.pickup_location"
                label="Pickup Location"
                id="pickup"
                :error="bookingForm.errors.pickup_location"
              />
            </v-flex>
            <v-icon
              style="padding-left: 4px; padding-right: 4px; padding-top: 12px;"
              @click="swapPickupAndDestination()"
            >swap_horiz</v-icon>
            <v-flex>
              <BookingLocationInput
                flatField
                @locationChanged="destinationUpdated"
                v-model="bookingForm.booking.destinations[0]"
                label="Destination Location"
                id="destination"
                :error="bookingForm.errors['destination_0']"
              />
            </v-flex>
          </v-layout>
          <div style="position: absolute; top: 8px; right: 0;">
            <v-btn
              style="padding: 0 9px !important; height: 40px; width: 8px; min-width: 8px !important; font-size: 12px !important; color: #333333"
              :elevation="1"
              color="white lighten-2"
              class="text-none"
              depressed
              @click="addViaAndExpand"
              v-html="viaCount != 0 ? (viaCount + '<br>+') : '+'"
            ></v-btn>
          </div>
        </v-layout>
        <v-flex v-if="bookingForm.booking.destinations.length >= 2" pb-1>
          <v-layout pr-5 mr-2 px-1 row wrap align-start>
            <v-flex pr-1 md6 sm12>
              <BookingLocationInput
                flatField
                @locationChanged="viaUpdated"
                v-model="bookingForm.booking.destinations[1]"
                label="Via 1"
                id="via1"
                :removable="true"
                :error="bookingForm.errors['destination_1']"
                @removePressed="function(){removeVia(1)}"
              />
            </v-flex>
            <v-flex pl-1 v-if="bookingForm.booking.destinations.length >= 3" md6 sm12>
              <BookingLocationInput
                flatField
                @locationChanged="viaUpdated"
                v-model="bookingForm.booking.destinations[2]"
                label="Via 2"
                id="via2"
                :removable="true"
                :error="bookingForm.errors['destination_2']"
                @removePressed="function(){removeVia(2)}"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex px-2>
          <!-- <v-divider ></v-divider> -->
          <v-layout row>
            <v-divider style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px;"></v-divider>
          </v-layout>
        </v-flex>
        <v-layout row>
          <v-flex shrink>
            <VehicleRequirementsInput :bookingForm="bookingForm" />
          </v-flex>
          <!-- <v-flex>
            <PassengerFindDetails :bookingForm="bookingForm" />
          </v-flex>-->
        </v-layout>
        <v-layout row pt-1>
          <v-flex shrink>
            <BookingDispatchInput :bookingForm="bookingForm" />
          </v-flex>
          <v-flex>
            <UserNotes @updateNotes="updateNotes" :bookingForm="bookingForm" />
          </v-flex>
        </v-layout>
        <v-flex px-2>
          <v-layout row>
            <v-divider style="margin-left: 12px; margin-top: 4px; margin-bottom: 7px;"></v-divider>
          </v-layout>
        </v-flex>
        <PaymentInput :bookingForm="bookingForm" @updateFinalCosts="updateFinalCosts" />
        <v-flex px-2>
          <v-layout row>
            <v-divider style="margin-left: 12px; margin-top: 2px; margin-bottom: 0px;"></v-divider>
          </v-layout>
        </v-flex>
        <b
          style="font-size: 12px; padding-left: 6px;"
          v-if="bookingForm.booking.state == null && bookingForm.user.recent_bookings.length > 0"
        >Recent Bookings</b>
        <UserRecentBookings
          v-if="bookingForm.booking.state == null && bookingForm.user.recent_bookings.length > 0"
          :bookingForm="bookingForm"
          :rebook="rebook"
          :allowView="false"
        />
      </v-flex>
    </v-layout>
    <v-layout style="position: absolute; bottom: 0; right: 0; left: 0;">
      <BookRideOptions
        :largeMode="false"
        @expand="expand"
        @close="close"
        @update="bookingForm.updateRide(updatedBooking)"
        @book="bookingForm.bookRide(madeBooking)"
        @cancel="function(params){bookingForm.cancelRide(cancelledBooking, params)}"
        :updateMode="updateMode"
        :bookingForm="bookingForm"
      />
    </v-layout>
  </form>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import BookingDateTimeInput from "@/components/widget/input/BookingDateTimeInput.vue";

import BookingDispatchInput from "@/components/widget/input/BookingDispatchInput.vue";
import BookRideOptions from "@/components/widget/input/BookRideOptions.vue";
import BusinessCustomerDetailsInput from "@/components/widget/input/BusinessCustomerDetailsInput.vue";
import VehicleRequirementsInput from "@/components/widget/input/VehicleRequirementsInput.vue";
import PassengerFindDetails from "@/components/widget/input/PassengerFindDetails.vue";
import PaymentInput from "@/components/widget/input/PaymentInput.vue";

import CustomerSearchInput from "@/components/widget/input/CustomerSearchInput.vue";
import UserNotes from "@/components/widget/input/UserNotes.vue";
import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import UserRecentBookings from "@/components/overwatch/UserRecentBookings.vue";

export default {
  name: "SmallBookForm",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingLocationInput,
    SimpleTextInput,
    BookingDispatchInput,
    SelectableInput,
    BookingDateTimeInput,
    BusinessCustomerDetailsInput,
    VehicleRequirementsInput,
    PassengerFindDetails,
    PaymentInput,
    CustomerSearchInput,
    UserNotes,
    BookTripETARoute,
    BookRideOptions,
    UserRecentBookings
  },
  props: {
    bookingForm: Object,
    expand: Function,
    updateMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userIsBusiness: function() {
      console.log("User is business " + this.bookingForm.user.business == true);
      return this.bookingForm.user.business == true;
    },
    viaCount: function() {
      var count = 0;

      for (var i = 1; i < this.bookingForm.booking.destinations.length; i++) {
        if (this.bookingForm.booking.destinations[i] != null) {
          count++;
        }
      }

      return count;
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    }
  },
  data() {
    return {
      loading: false,
      forceAddLeadPAX: false
    };
  },
  methods: {
    rebook(booking) {
      this.bookingForm.rebook(booking);

      this.$emit("locationsChanged", "");
    },
    bookingHasBusinessAttributes: function() {
      return (
        (this.bookingForm.booking.authorized_by != null &&
          this.bookingForm.booking.authorized_by != "") ||
        (this.bookingForm.booking.business_customer_name != null &&
          this.bookingForm.booking.business_customer_name != "") ||
        (this.bookingForm.booking.business_customer_number != null &&
          this.bookingForm.booking.business_customer_number != "") ||
        (this.bookingForm.booking.business_customer_email != null &&
          this.bookingForm.booking.business_customer_email != "") ||
        (this.bookingForm.booking.business_customer_reference &&
          this.bookingForm.booking.business_customer_reference != "")
      );
    },
    updateFinalCosts: function() {
      console.log("Updating final costs");
      this.bookingForm.updateFinalCosts();
    },
    updateNotes: function() {
      console.log("Updating notes");
      this.bookingForm.updateNotes();
    },
    expand: function() {
      this.$emit("expand", null);
    },
    close: function() {
      this.$emit("close", null);
    },
    cancelledBooking: function() {
      this.$emit("cancelledBooking", null);
    },
    updatedBooking: function() {
      this.$emit("updatedBooking", null);
    },
    madeBooking: function() {
      this.$emit("madeBooking", null);
    },
    swapPickupAndDestination: function() {
      this.bookingForm.swapPickupAndDestination();
      this.$emit("locationsChanged", "");
    },
    addViaAndExpand: function() {
      this.bookingForm.addVia();

      if (this.bookingForm.booking.destinations.length >= 4) {
        this.expand();
      }
    },
    getCostEstimate: function(loc) {
      console.log("Get cost estimate smallbookform");
      this.bookingForm.getCostEstimate();
    },
    pickupUpdated: function(loc) {
      this.bookingForm.booking.pickup_location = loc;
      this.getCostEstimate();

      this.$emit("locationsChanged", "");
    },
    destinationUpdated: function(loc) {
      this.bookingForm.booking.destinations[0] = loc;
      this.getCostEstimate();

      this.$emit("locationsChanged", "");
    },
    viaUpdated: function(loc) {
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    removeVia: function(index) {
      this.bookingForm.booking.destinations.splice(index, 1);
      this.bookingForm.booking.via_info.splice(index - 1, 1);

      this.getCostEstimate();

      this.$emit("locationsChanged", "");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.bottom-trip-info {
  background-color: #cccccc;
  height: 28px;
  min-height: 28px !important;
  border-radius: 8px;
  padding-left: 18px;
  padding-right: 18px;
  font-weight: 500;
  font-size: 12px;
}

.small-button {
  font-size: 12px !important;
}

html {
  overflow: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 0px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  // background: #ff0000;
}

.disabled-panel {
  pointer-events: none;
}

.small-book-form input {
  font-size: 13px !important;
}

.small-book-form .v-text-field.v-text-field--enclosed .v-text-field__details,
.small-book-form
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0 7px !important;
}

.small-book-form .v-label {
  padding-left: 8px !important;
}

.small-book-form .v-input__slot {
  min-height: 32px !important;
}
</style>
